export default __webpack_public_path__ + "static/media/item8.52d55c5d.jpg";